export const ErrorType = {
    LINK_EXPIRED: "LINK_EXPIRED"
}